// Single on/off switch for ALL brand debug alerts, taken from the build-time env
// (VUE_APP_DEBUG_OPTION in .env, or the env var set where the build runs).
// Anything other than the exact string 'true' means debug is OFF.
export function isBrandDebugEnabled() {
    return `${process.env.VUE_APP_DEBUG_OPTION}` === 'true';
}

export function showBrandDebugAlert(brandConfig, message) {
    if (!isBrandDebugEnabled()) return;

    const brandLabel = brandConfig?.brand || brandConfig?.assetBrand || 'unknown-brand';
    alert(`[DEBUG ${brandLabel}] ${message}`);
}
